import { InnerMediaBlock } from '@prismamedia/one-components';
import { ArticleVideoButton } from './ArticleVideoButton';

export const ArticleVideoPlugin = {
  type: 'articlevideo',
  buttonComponent: ArticleVideoButton,
  blockComponent: InnerMediaBlock,
};
